import SvgCalendar from '../../../assets/images/Icons/SVG/Calendar';
import moment from 'moment';
import SelectedInfoPanel from '../../common/SelectedInfoPanel';

export default function SelectedDatesPanel({
  arrival,
  departure,
  className = '',
}) {
  const formatDate = (date) => {
    if (moment(date).isValid()) {
      return moment(date).format('Do MMMM YYYY');
    }
    return null;
  };

  const arrivalString = formatDate(arrival);
  let departureString = null;
  if (!moment(arrival).isSame(moment(departure))) {
    departureString = formatDate(departure);
  }

  return (
    <SelectedInfoPanel
      title='Your date(s)'
      showPlaceholder={!arrivalString}
      content={
        <>
          {arrivalString}
          {departureString ? ` – ${departureString}` : ''}
        </>
      }
      placeholder='Select Your Dates On The Calendar Above'
      icon={<SvgCalendar />}
      className={className}
    />
  );
}
